
   /**
    *分享
    * 
    * @param PC_Id OC参数
    * @param Mobile_id 手机参数
    * @param PC_URL PC地址
    * @param Mobile_URL 手机地址
    */
   export function Adaptation1 (_this,PC_Id,  Mobile_id, PC_URL, Mobile_URL) {
   //判断是否是PC设备，true是，false不是
         //判断是否是PC设备，true是，false不是
         let userAgentInfo = navigator.userAgent
         console.log(navigator.userAgent)
         let Agents = ['Android', 'iPhone', 'SymbianOS', 'Windows Phone', 'iPod']
         let flag = true
         for (let j = 0; j < Agents.length; j++) {
           console.log(userAgentInfo.indexOf(Agents[j]))
           if (userAgentInfo.indexOf(Agents[j])>0) {
             flag = false
             break
           }
         }
         console.log(window.screen.width)
         if (window.screen.width >= 768) {
           flag = true
         }
         if (flag) {
            _this.$router.push({
             path: PC_URL,
             query: { id: PC_Id },
           })
         } else {
           window.location.href=this.Urls+"/Mobile/index.html#/" + Mobile_URL + Mobile_id
            
         }
   };